import React, { useState } from 'react';
import {
  Box,
  Typography,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import RefreshIcon from '@mui/icons-material/Refresh';
import PrintIcon from '@mui/icons-material/Print';
import FileDownloadIcon from '@mui/icons-material/FileDownload';

const SuccessPopup = ({
  open,
  setOpen,
  type, // 'success' or 'error'
  title,
  message,
  onCreateNew,
  onPrint,
  onSeeInvoices,
  invoiceData,
  isPurchase,
}) => {
  // Determine target tab based on invoice type
  const targetTab = isPurchase ? 0 : 1;

  return (
    <Dialog
      open={open}
      maxWidth="sm"
      fullWidth
      onClose={() => setOpen(false)}
      PaperProps={{
        sx: {
          borderRadius: 2,
          boxShadow: '0 8px 32px rgba(0, 0, 0, 0.12)',
          p: 3,
        }
      }}
    >
      <DialogTitle sx={{ textAlign: 'center', pb: 1 }}>
        {type === 'success' ? (
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, justifyContent: 'center' }}>
            <CheckCircleIcon sx={{ color: '#4caf50', fontSize: 32 }} />
            <Typography variant="h6" sx={{ fontWeight: 600, color: '#2e7d32' }}>
              Success!
            </Typography>
          </Box>
        ) : (
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, justifyContent: 'center' }}>
            <ErrorOutlineIcon sx={{ color: '#f44336', fontSize: 32 }} />
            <Typography variant="h6" sx={{ fontWeight: 600, color: '#c62828' }}>
              Error
            </Typography>
          </Box>
        )}
      </DialogTitle>

      <DialogContent sx={{ textAlign: 'center' }}>
        <Typography variant="body1" sx={{ mb: 3, color: '#333' }}>
          {message}
        </Typography>

        {/* Action buttons */}
        <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center', flexWrap: 'wrap' }}>
          {type === 'success' ? (
            <>
              <Button
                variant="contained"
                color="primary"
                onClick={onCreateNew}
                startIcon={<RefreshIcon />}
                sx={{ 
                  px: 3, 
                  py: 1,
                  borderRadius: 2,
                  textTransform: 'none',
                  fontWeight: 500,
                }}
              >
                Create New
              </Button>
              <Button 
                variant="outlined" 
                onClick={onPrint}
                startIcon={<PrintIcon />}
                sx={{ 
                  px: 3, 
                  py: 1,
                  borderRadius: 2,
                  textTransform: 'none',
                  fontWeight: 500,
                }}
              >
                Print
              </Button>
            </>
          ) : (
            <>
              <Button 
                variant="contained" 
                color="primary"
                onClick={onCreateNew}
                startIcon={<RefreshIcon />}
                sx={{ 
                  px: 3, 
                  py: 1,
                  borderRadius: 2,
                  textTransform: 'none',
                  fontWeight: 500,
                }}
              >
                Try Again
              </Button>
              <Button 
                variant="contained" 
                color="primary"
                onClick={onSeeInvoices}
                startIcon={<FileDownloadIcon />}
                sx={{ 
                  px: 3, 
                  py: 1,
                  borderRadius: 2,
                  textTransform: 'none',
                  fontWeight: 500,
                }}
              >
                Go Back
              </Button>
            </>
          )}
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default SuccessPopup;